import { TextField } from '@mui/material';
import DatePicker from '@mui/lab/DatePicker';
import { useController } from 'react-hook-form';

type FormDatepickerFieldProps = {
  name: `${string}` | `${string}.${string}` | `${string}.${number}`;
  label?: string;
  rules?: Object;
  error?: boolean;
  helperText?: string;
};

export function FormDatepickerField({ name, label, rules, error, helperText }: FormDatepickerFieldProps) {
  const {
    field: { onChange, value, ref },
  } = useController({
    name,
    rules,
  });

  return (
    <DatePicker
      clearable
      label={label}
      value={value}
      onChange={onChange}
      renderInput={params => (
        <TextField
          id={name}
          {...params}
          error={error}
          helperText={helperText}
          inputRef={inputRef => {
            if (params.inputRef && typeof params.inputRef === 'function') {
              params.inputRef(inputRef);
            }
            ref(inputRef);
          }}
        />
      )}
      mask='__-__-__'
      inputFormat='MM-dd-yy'
    />
  );
}
